import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import React from "react";
import { useHistory } from "react-router-dom";
import { connect } from 'react-redux';
import axios from 'axios';


import { Button, Card, CardHeader, CardBody, FormGroup, Input, InputGroupAddon, InputGroupText, InputGroup, Row, Col,} from "reactstrap";

const Login = (props) => {
    const history = useHistory();
    const [sendingdata, setSendingdata] = React.useState('');
    const [tt, settt] = React.useState('');
    const [open, setOpen] = React.useState(false);

    const [type, setType] = React.useState('Username');
    const [main, setMain] = React.useState();
    var place = 'Enter '+type
    // console.log(props.username)
    // console.log(props)
    const handleChangeS = (event) => {
        setType(event.target.value)
    };
    const handleChangeA = (event) => {
        setMain(event.target.value)
    };
    const handleClose = (event, reason) => {
        setOpen(false);
    };
    const handleKeypress = e => {
        //it triggers by pressing the enter key
        if (e.keyCode === 13) {
            loginPageHandler();
        }
    };
    const loginPageHandler = () => {
        if (main === undefined) {
            setSendingdata('Please Enter the '+type+' properly')
            settt('error');
            setOpen(true);
            return 0;
        }
        if (main.length < 1){
            setSendingdata('Please Enter the '+type+' properly')
            settt('error');
            setOpen(true);
            return 0;
        }
        setSendingdata('Please wait a sec')
        settt('success');
        setOpen(true);
        const ran = Math.floor((Math.random() * 999999) + 100000);
        const ran2 = ran.toString();
        var inp = {
            'main': main,
            'type': type,
            'random': ran2
        }
        // console.log(inp)
        axios.post(process.env.REACT_APP_DOMAIN+'/forgotpassword', inp)
            .then((response) => {
                // console.log(response.data)
                if(response.data.status ===201){
                    // console.log('yes')
                    history.push({
                        pathname: '/auth/confirm-password',
                        state: response.data
                    })
                }
                else{
                    setSendingdata(response.data.message)
                    settt('error')
                    setOpen(true)
                }
            })
            .catch((error) => {
                setSendingdata('Something Went Wrong, Please try again')
                settt('error')
                setOpen(true)
            })
    };
    return (
        <>
            <Col lg="15" md="7">
                <Card className="bg-secondary shadow border-0">
                    <CardHeader className="bg-transparent pb-5">
                        <div className="btn-wrapper text-center">
                            <Button
                                className="btn-neutral btn-icon"
                                color="default"
                                href="#pablo"
                                onClick={(e) => e.preventDefault()}
                            >
                                <span className="btn-inner--icon">
                                    <img
                                        alt="..."
                                        src={
                                            require("../../assets/img/kj.png")
                                                .default
                                        }
                                    />
                                </span>
                                <span className="btn-inner--text">Forgot Password</span>
                            </Button>
                        </div>
                    </CardHeader>
                    <CardBody className="px-lg-5 py-lg-5">
                        <Row className="row">
                            <Col className="" sm={12} lg={12}>
                                <FormGroup className="mb-3">
                                    <InputGroup className="input-group-alternative">
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>
                                                <i className="ni ni-badge" />
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Input
                                            placeholder="Contact Info 1"
                                            type="select"
                                            autoComplete=""
                                            onChange={handleChangeS}
                                        >
                                            <option value="Username">Username</option>
                                            <option value="Email">Email</option>
                                            <option value="Contact">Contact</option>
                                        </Input>
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col className="" sm={12} lg={12}>
                                <FormGroup className="mb-3">
                                    <InputGroup className="input-group-alternative">
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>
                                                <i className="ni ni-key-25" />
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Input
                                            placeholder={place}
                                            type="text"
                                            autoComplete=""
                                            onChange={handleChangeA}
                                            onKeyDown={handleKeypress}
                                        />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} open={open} autoHideDuration={6000} onClose={handleClose}>
                            <MuiAlert elevation={6} variant="filled" onClose={handleClose} severity={tt}>{sendingdata}</MuiAlert>
                        </Snackbar>
                        <div className="custom-control custom-control-alternative custom-checkbox">
                        </div>
                        <div className="text-center">
                            <Button className="my-0" color="primary" type="button"
                                onClick={loginPageHandler}>
                                Go
                                </Button>
                        </div>
                    </CardBody>
                </Card>
                <Row className="mt-3">
                    <Col xs="6">
                        <a
                            className="text-light"
                            href="login"
                        >
                            <small>Login</small>
                        </a>
                    </Col>
                    <Col className="text-right" xs="6">
                        <a
                            className="text-light"
                            href="signup"
                        >
                            <small>Create new account</small>
                        </a>
                    </Col>
                </Row>
            </Col>
        </>
    );
};

// export default Login;

export const mapStateToProps = state => {
    // console.log("this is the state", state);
    return {
        adminValue: state.switchRoutes.admin,
        userValue: state.switchRoutes.user,
        username: state.userName,
    }
}

export default connect(mapStateToProps)(Login);